export function mapWalletPrefill(profile) {
  const empty = {
    phoneDigits: '',
    email: '',
    firstName: '',
    lastName: '',
    city: '',
    fromWallet: false,
  };
  if (!profile || profile.source !== 'google_wallet') {
    return empty;
  }
  const digits = String(profile.phone || '').replace(/\D/g, '');
  let phoneDigits = '';
  if (digits.length >= 11 && (digits.startsWith('7') || digits.startsWith('8'))) {
    phoneDigits = digits.slice(1, 11);
  } else if (digits.length >= 10) {
    phoneDigits = digits.slice(-10);
  } else {
    phoneDigits = digits;
  }
  return {
    phoneDigits,
    email: profile.email || '',
    firstName: profile.first_name || '',
    lastName: profile.last_name || '',
    city: profile.city || '',
    fromWallet: true,
  };
}

export function saveToGoogleWalletUrl(jwt, fromWallet) {
  if (!fromWallet || !jwt) {
    return null;
  }
  return 'https://pay.google.com/gp/v/save/' + jwt;
}

export function googleWalletTargetUrl(jwt, fromWallet) {
  // Ignore any object deep link. It 404s unless this Google account
  // already holds the pass. The save link adds it to the signed-in account.
  return saveToGoogleWalletUrl(jwt, fromWallet);
}

export function cardSerialFromPath(serialNumber) {
  if (!serialNumber || serialNumber === 'google-wallet') {
    return null;
  }
  return serialNumber;
}

export function walletPrefillStorageKey(alias) {
  return 'wollzy.googleWalletPrefill.' + alias;
}

function sessionStore(storage) {
  if (storage) {
    return storage;
  }
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  return sessionStorage;
}

export function readStoredWalletPrefill(alias, storage) {
  const store = sessionStore(storage);
  if (!alias || !store) {
    return mapWalletPrefill(null);
  }
  try {
    const raw = store.getItem(walletPrefillStorageKey(alias));
    if (!raw) {
      return mapWalletPrefill(null);
    }
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.fromWallet !== true) {
      return mapWalletPrefill(null);
    }
    return {
      phoneDigits: parsed.phoneDigits || '',
      email: parsed.email || '',
      firstName: parsed.firstName || '',
      lastName: parsed.lastName || '',
      city: parsed.city || '',
      fromWallet: true,
    };
  } catch (e) {
    return mapWalletPrefill(null);
  }
}

export function writeStoredWalletPrefill(alias, mapped, storage) {
  const store = sessionStore(storage);
  if (!alias || !mapped || !mapped.fromWallet || !store) {
    return;
  }
  store.setItem(walletPrefillStorageKey(alias), JSON.stringify(mapped));
}

export function clearStoredWalletPrefill(alias, storage) {
  const store = sessionStore(storage);
  if (!alias || !store) {
    return;
  }
  store.removeItem(walletPrefillStorageKey(alias));
}
